var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.layout === 'mobile' && (_vm.$route.meta.header === undefined || _vm.$route.meta.header === true))?_c('div',{staticClass:"mobile-header"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/wifi-block-logo.svg")},on:{"click":function($event){return _vm.$router.push('/')}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }